import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"max-width":"300px"} }

import { NCard, NGi, NGrid, NText, NEllipsis } from "naive-ui";
import { computed, withDefaults } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    title: { default: "" },
    desc: { default: "" },
    minHeight: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { title: string, desc: string, minHeight: number }


const height = computed(() => {
  if (props.minHeight === 0) {
    return "auto";
  }
  return props.minHeight + "px";
});
const optionHeight = computed(() => {
  if (props.minHeight === 0) {
    return "100%";
  }
  return props.minHeight - 30 + "px";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NCard), {
    hoverable: "",
    "content-style": `padding: 15px 5px 15px 15px;min-height:${_unref(height)}`
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NGrid), {
        cols: "10",
        style: {"height":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NGi), { span: "9" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_unref(NText), { depth: "1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.title), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_unref(NText), { depth: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NEllipsis), { "line-clamp": 4 }, {
                      tooltip: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(props.desc), 1)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.desc) + " ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(NGi), { span: "1" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                style: _normalizeStyle(`
            display: flex;
            justify-content: center;
            align-items: center;
            height: ${_unref(optionHeight)};
          `)
              }, [
                _renderSlot(_ctx.$slots, "default")
              ], 4)
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["content-style"]))
}
}

})